import { Decorable } from '../types/decorable';
// @ts-ignore
import { LngLatBounds } from '!mapbox-gl';
import { MapConfig } from './api-services/map-api.service';
import { BBOX } from '../types/@types/sl-v-types';


export class SLProject {

	private data: Decorable;

	get access(): number {
		return this.data.access;
	}

	get description(): string {
		return this.data.descritpion;
	}

	get extents(): [number, number, number, number] {
		const extents: Array<string> = this.data.extents.projected.split(',');
		const numExtents: [number, number, number, number] = [
			Number(extents[0]),
			Number(extents[1]),
			Number(extents[2]),
			Number(extents[3])
		];

		return numExtents;
	}
	set extents(bbox: [number, number, number, number]) {
		this.data.extents.projected = bbox.join(',');
	}
	set extentString(bbox: BBOX) {
		this.data.extents.projected = bbox;
	}
	get bounds(): LngLatBounds {
		const bounds: LngLatBounds = new LngLatBounds(this.extents);
		return bounds;
	}

	get id(): string {
		return this.data.id;
	}

	get layers(): Array<Decorable> {
		return this.data.layers;
	}

	get lpa(): boolean {
		return this.data.lpa === '1';
	}

	get name(): string {
		return this.data.name;
	}

	get owner(): string {
		return this.data.owner;
	}
	get ownerName(): string {
		return this.data.owner_name;
	}
	get private(): boolean {
		return this.data.private === '1';
	}

	get tags(): Array<string> {
		return this.data.tags.split(',');
	}

	get viewer(): string {
		return this.data.viewer;
	}
	get viewerName(): string {
		return this.data.viewer_name;
	}
	get config(): MapConfig {
		return this.data.config;
	}
	set config(newConfig: MapConfig) {
		for (const key in newConfig) {
			if (newConfig.hasOwnProperty(key)) {
				this.data.config[key] = newConfig[key];
			}
		}
	}

	constructor(projectData: Decorable) {
		this.data = projectData;
	}



}

